import { createComponent } from '../lib';
import { VmSlider } from '@vime/core';
import { define } from '../lib';
define('vm-slider', VmSlider);
;
export default createComponent('vm-slider', new Set(['step', 'min', 'max', 'value', 'valueText', 'label']));
//# sourceMappingURL=Slider.jsx.map